import type { Module } from 'vuex';
import { TranslateActionError } from '@/types/TranslateActionError';
import {RootState} from "@/store";

export interface TranslateActionErrorsState {
  translateActionErrors: TranslateActionError[];
}

const translateActionErrorsModule: Module<TranslateActionErrorsState, RootState> = {
  namespaced: true,

  state: (): TranslateActionErrorsState => ({
    translateActionErrors: [],
  }),

  getters: {
    getById: (state) => (idTranslateActionError: number): TranslateActionError | undefined => {
      return state.translateActionErrors.find(translateActionError => translateActionError.idTranslateActionError === idTranslateActionError);
    },
    getByActionError: (state) => (idActionError: number): TranslateActionError[] => {
      return state.translateActionErrors.filter(translateActionError => translateActionError.idActionError === idActionError);
    },
  },

  mutations: {
    setTranslateActionErrors(
      state,
      payload: { translateActionErrors: Record<number, any> }
    ) {
      state.translateActionErrors = Object
        .values(payload.translateActionErrors)
        .map(raw => TranslateActionError.fromRaw(raw));
    },

    setTranslateActionErrorCreate(
      state,
      payload: {
        idTranslateActionError: number;
        idActionError: number;
        idLanguage: number;
        text: string;
      }
    ) {
      const raw = {
        idTranslateActionError: payload.idTranslateActionError,
        idActionError: payload.idActionError,
        idLanguage: payload.idLanguage,
        text: payload.text,
        locked: false,
      };
      state.translateActionErrors.push(TranslateActionError.fromRaw(raw));
    },

    setTranslateActionErrorUpdate(
      state,
      payload: {
        idTranslateActionError: number;
        text?: string;
      }
    ) {
      const translateActionError = state.translateActionErrors.find(translateActionError => translateActionError.idTranslateActionError === payload.idTranslateActionError);
      if (!translateActionError) return;
      if (payload.text !== undefined) translateActionError.text = payload.text;
    },

    setTranslateActionErrorDelete(
      state,
      payload: { idTranslateActionError: number }
    ) {
      state.translateActionErrors = state.translateActionErrors.filter(
        translateActionError => translateActionError.idTranslateActionError !== payload.idTranslateActionError
      );
    },

    setTranslateActionErrorLock(
      state,
      payload: { idTranslateActionError: number }
    ) {
      const translateActionError = state.translateActionErrors.find(translateActionError => translateActionError.idTranslateActionError === payload.idTranslateActionError);
      if (translateActionError) translateActionError.locked = true;
    },

    setTranslateActionErrorUnlock(
      state,
      payload: { idTranslateActionError: number }
    ) {
      const translateActionError = state.translateActionErrors.find(translateActionError => translateActionError.idTranslateActionError === payload.idTranslateActionError);
      if (translateActionError) translateActionError.locked = false;
    },
  },

  actions: {
    wsSetTranslateActionErrors({ commit }, payload) {
      commit('setTranslateActionErrors', payload);
    },
    wsTranslateActionErrorCreate({ commit }, payload) {
      commit('setTranslateActionErrorCreate', payload);
    },
    wsTranslateActionErrorUpdate({ commit }, payload) {
      commit('setTranslateActionErrorUpdate', payload);
    },
    wsTranslateActionErrorDelete({ commit }, payload) {
      commit('setTranslateActionErrorDelete', payload);
    },
    wsTranslateActionErrorLock({ commit }, payload) {
      commit('setTranslateActionErrorLock', payload);
    },
    wsTranslateActionErrorUnlock({ commit }, payload) {
      commit('setTranslateActionErrorUnlock', payload);
    },
  },
};

export default translateActionErrorsModule;
